<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar puntada</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre de puntada"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-height"
                class="col-3"
                label="Altura"
                label-for="height"
              >
                <b-input-group>
                  <b-form-input
                    id="height"
                    :value="$v.form.height.$model.replace('.', ',')"
                    @change="setDecimal('height', $event)"
                    :state="validateState('height')"
                    aria-describedby="input-height-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-height-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="mt-2">
              <b-form-group
                id="input-icon"
                class="col-3"
                label="Icono"
                label-for="icon"
                description="Dejar vacío para mantener el icono actual"
              >
                <b-form-file
                  accept="icon/*"
                  id="icon"
                  v-model="$v.form.icon.$model"
                  :state="validateState('icon')"
                  @input="changedIcon"
                  aria-describedby="input-icon-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-icon-feedback"
                  >Debes seleccionar una iconn válida (formato PNG o
                  JPEG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-col cols="auto">
                <label>Vista previa icono &nbsp; </label>
                <b-form-row>
                  <b-form-group id="input-preview" class="col-auto">
                    <div>
                      <img
                        style="max-height: 10rem; border: 1px solid #ebebeb"
                        :src="form.iconURI"
                      />
                    </div>
                  </b-form-group>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-3">
              <!-- Code hex -->
              <b-form-group
                id="input-image"
                class="col-3"
                label="Imagen"
                label-for="image"
                description="Dejar vacío para mantener la imagen actual"
              >
                <b-form-file
                  accept="image/*"
                  id="image"
                  v-model="$v.form.image.$model"
                  :state="validateState('image')"
                  @input="changedImage"
                  aria-describedby="input-image-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-image-feedback"
                  >Debes seleccionar una imagen válida (formato
                  SVG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-col cols="4" class="text-center">
                <label>Detalle imagen &nbsp; </label>
                <b-form-row>
                  <b-col cols="12">
                    <img
                      style="max-height: 10rem"
                      width="100%"
                      :src="form.imageURI"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-3">
              <!-- Code hex -->
              <b-form-group
                id="input-image_white"
                class="col-3"
                label="Imagen (blanca)"
                label-for="image_white"
                description="Dejar vacío para mantener la imagen actual"
              >
                <b-form-file
                  accept="image/*"
                  id="image_white"
                  v-model="$v.form.image_white.$model"
                  :state="validateState('image_white')"
                  @input="changedImageWhite"
                  aria-describedby="input-image_white-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-image_white-feedback"
                  >Debes seleccionar una imagen válida (formato
                  SVG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-col cols="4" class="text-center">
                <label>Detalle imagen (sobre fondo gris)&nbsp; </label>
                <b-form-row>
                  <b-col cols="12" style="background: #ebebeb; height: 10rem">
                    <img
                      style="max-height: 10rem"
                      width="100%"
                      :src="form.image_whiteURI"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
              <b-col>
                <h4>Tamaños y alturas</h4>

                <!-- <b-button size="sm" variant="outline-primary" @click="addSize"
                  >Nuevo tamaño</b-button
                > -->

                <b-form-row class="mt-4">
                  <b-col :cols="2"><label>Tamaño</label> </b-col>
                  <!-- <b-col :cols="2"><label>Centímetros</label> </b-col> -->
                  <b-col :cols="2"><label>Altura</label> </b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.sizes.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2"
                    ><b-form-group id="input-group-name" label-for="input-name">
                      <b-form-input
                        :disabled="true"
                        v-model="v.name.$model"
                        :state="validateStateSize(i, 'name')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col :cols="2">
                    <b-form-group
                      id="input-group-centimeters"
                      label-for="input-centimeters"
                    >
                      <b-input-group append="cm">
                        <b-form-input
                          id="centimeters"
                          :value="v.centimeters.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'centimeters', $event)"
                          :state="validateStateSize(i, 'centimeters')"
                          aria-describedby="input-centimeters-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-height"
                      label-for="input-height"
                    >
                      <b-input-group append="cm">
                        <b-form-input
                          id="height"
                          :value="v.height.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'height', $event)"
                          :state="validateStateSize(i, 'height')"
                          aria-describedby="input-height-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="auto"
                    ><b-button
                      :disabled="form.sizes.length === 1"
                      @click="removeSize(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col> -->
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
              <b-col>
                <h4>Características</h4>

                <!-- <b-button size="sm" variant="outline-primary" @click="addSize"
                  >Nuevo tamaño</b-button
                > -->

                <b-form-row>
                  <b-col :cols="2"
                    ><b-form-group label="Tipo de unión">
                      <b-form-radio
                        v-model="$v.form.route_type.$model"
                        name="some-radios"
                        value="overlapped"
                        >Superpuesto</b-form-radio
                      >
                      <b-form-radio
                        v-model="$v.form.route_type.$model"
                        name="some-radios"
                        value="simple"
                        >Simple</b-form-radio
                      >
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>
            <!-- <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-name_' + lang"
                :label="
                  languageCodes.length > 1
                    ? 'Nombre (' + languageNames[i] + ')'
                    : 'Nombre'
                "
                :label-for="'name_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'name_' + lang"
                  v-model="$v.form['name_' + lang].$model"
                  :state="validateState('name_' + lang)"
                  :aria-describedby="'input-name_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-name_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row> -->

            <b-button type="submit" variant="primary">Guardar puntada</b-button>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/svg+xml', 'image/svg'].includes(image['type']);

const isValidIcon = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminColorsEditScreen',
  props: ['id'],
  components: {},
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
      height: { required },
      image: {
        isValidImage,
      },
      image_white: {
        isValidImage,
      },
      icon: {
        isValidIcon,
      },
      sizes: {
        $each: {
          name: {
            required,
          },
          height: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
          // centimeters: {
          //   required,
          //   decimal,
          //   minValue: minValue(0.0),
          // },
        },
      },
      route_type: {
        required,
      },
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      image: null,
      image_white: null,
      icon: null,
      reference: '',
      height: '',
      imageURI: null,
      image_whiteURI: null,
      iconURI: null,
      sizes: [
        { name: 'Pequeño', height: '' },
        { name: 'Mediano', height: '' },
        { name: 'Grande', height: '' },
      ],
      route_type: '2',
      error: {
        show: false,
        text: '',
      },
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    if (this.id !== 'new') {
      actions.getStitch(this.id).then((x) => {
        const data = x.data;

        this.form.reference = data.reference;

        this.form.imageURI = data.image;
        this.form.image_whiteURI = data.image_white;
        this.form.iconURI = data.icon;
        this.form.height = data.height;

        this.form.sizes = data.sizes;
        this.form.route_type = data.route_type;

        // this.languageCodes.map((y) => {
        //   this.form['name_' + y] = data['name_' + y];
        // });
      });
    }
  },
  methods: {
    validateStateSize(index, name) {
      const { $dirty, $error } = this.$v.form.sizes.$each.$iter[index][name];
      return $dirty ? !$error : null;
    },
    addSize() {
      this.form.sizes.push({ name: '', height: '0.0' });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalSize(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.sizes.$each.$iter[index][name].$model = val;
      this.$v.form.sizes.$each.$iter[index][name].$touch();
    },
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    changedImageWhite(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.image_whiteURI = result;
      });
    },
    changedIcon(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.iconURI = result;
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      if (this.form.image !== null) {
        data.append('image', this.form.image);
      }

      if (this.form.image_white !== null) {
        data.append('image_white', this.form.image_white);
      }

      if (this.form.icon !== null) {
        data.append('icon', this.form.icon);
      }

      data.append('reference', this.form.reference);
      data.append('height', this.form.height);
      data.append('sizes', JSON.stringify(this.form.sizes));
      data.append('route_type', this.form.route_type);

      // this.languageCodes.map((x) => {
      //   data.append('name_' + x, this.form['name_' + x]);
      // });

      // data.append('name', this.form['name_' + this.languageCodes[0]]);

      if (this.id !== 'new') {
        actions.patchStitch(this.id, data).then(() => {
          this.$router.push({ name: 'AdminStitchesScreen' });
        });
      } else {
        actions.postStitch(data).then((x) => {
          this.$router.push({ name: 'AdminStitchesScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
